"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.record = record;
const utils_1 = require("@aws-amplify/core/internals/utils");
const core_1 = require("@aws-amplify/core");
const utils_2 = require("../utils");
const utils_3 = require("../../../utils");
const constants_1 = require("../utils/constants");
const logger = new core_1.ConsoleLogger('Personalize');
function record(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    const { userId, eventId, eventType, properties } = input;
    if (!(0, utils_3.isAnalyticsEnabled)()) {
        logger.debug('Analytics is disabled, event will not be recorded.');
        return;
    }
    const { region, trackingId, bufferSize, flushSize, flushInterval } = (0, utils_2.resolveConfig)(ctx);
    (0, utils_3.resolveCredentials)(ctx)
        .then(async ({ credentials, identityId }) => {
        const timestamp = Date.now();
        const { sessionId: cachedSessionId, userId: cachedUserId } = await (0, utils_2.resolveCachedSession)();
        if (eventType === constants_1.IDENTIFY_EVENT_TYPE) {
            (0, utils_2.updateCachedSession)(typeof properties.userId === 'string' ? properties.userId : '', cachedSessionId, cachedUserId);
        }
        else if (userId) {
            (0, utils_2.updateCachedSession)(userId, cachedSessionId, cachedUserId);
        }
        const { sessionId: updatedSessionId, userId: updatedUserId } = await (0, utils_2.resolveCachedSession)();
        const eventBuffer = (0, utils_2.getEventBuffer)({
            region,
            flushSize,
            flushInterval,
            bufferSize,
            credentials,
            identityId,
            userAgentValue: (0, utils_3.getAnalyticsUserAgentString)(utils_1.AnalyticsAction.Record),
        });
        if (eventType === constants_1.MEDIA_AUTO_TRACK_EVENT_TYPE) {
            (0, utils_2.autoTrackMedia)({
                trackingId,
                sessionId: updatedSessionId,
                userId: updatedUserId,
                event: {
                    eventId,
                    eventType,
                    properties,
                },
            }, eventBuffer);
        }
        else {
            eventBuffer.append({
                trackingId,
                sessionId: updatedSessionId,
                userId: updatedUserId,
                event: {
                    eventId,
                    eventType,
                    properties,
                },
                timestamp,
            });
        }
        if (eventBuffer.length >= bufferSize) {
            eventBuffer.flushAll();
        }
    })
        .catch(e => {
        logger.warn('Failed to record event.', e);
    });
}
